"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function matchIs(value) {
    return item => item.contentType === value;
}
exports.matchIs = matchIs;
//# sourceMappingURL=match-is.js.map